import { module as modular } from "modujs";

export default class extends modular {
	constructor(m) {
		super(m);
		this.events = {
			click: {
				btn: "togglefilters",
				reset: "reset",
				// change: "change",
				open: "toggleSidebar",
				resetall: "resetall",
				refresh: "refresh",
				pagination: "pagination",
				changeMonth: "refreshMonth",
				reset: "reset",
				checked: "checked",
			},
			change: {
				change: "change",
			},
		};

		this.ajaxurl = "/wp/wp-admin/admin-ajax.php";
	}

	init() {
		if (this.getData("init")) {
			setTimeout(() => {
				this.refresh();
			}, 500);
		}
	}

	refresh(e) {
		let form = $(this.el);
		let target = form;
		jQuery.ajax({
			url: this.ajaxurl,
			type: "POST",
			data: form.serialize(),
			beforeSend: function () {
				if (target.find(".b-relation_listing").length) {
					target
						.find(".b-relation_listing")
						.html("<p>Recherche en cours ....</p>");
				}
				if (target.find(".b-relation_pagination").length) {
					target.find(".b-relation_pagination").html("");
				}
				if (target.find(".b-relation_count").length) {
					target.find(".b-relation_count").html("");
				}
			},
			success: function (response) {
				if (target.find(".b-relation_listing").length) {
					target.find(".b-relation_listing").html(response.content);
				}

				if (target.find(".b-relation_pagination").length) {
					target.find(".b-relation_pagination").html(response.pagination);
				}

				if (target.find(".b-relation_count").length) {
					target.find(".b-relation_count").html(response.count);
				}
			},
		});
	}

	change() {
		let form = $(this.el);
		$(form).find('input[name="paged"]').val("1");
		$(form).find('input[name="pagination"]').val("");

		this.refresh();
	}

	checked(e) {
		const target = e.currentTarget;
		const items = target;
		let check = false;

		for (let i = 0; i < 4; i++) {
			if (items[i].classList.contains("is-active")) {
				items[i].classList.remove("is-active");
				check == true;
			}
		}

		if (check !== true) {
			item.classList.add("-checked");
		}
	}

	pagination(e) {
		const el = e.currentTarget;
		let paged = el.getAttribute("data-paged");
		let form = $(this.el);
		$(form).find('input[name="paged"]').val(paged);
		$(form).find('input[name="pagination"]').val("true");

		this.refresh();
	}
}
